import { render, staticRenderFns } from "./VideosLista.vue?vue&type=template&id=63d77684&"
import script from "./VideosLista.vue?vue&type=script&lang=js&"
export * from "./VideosLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports